import {
  AlanCredential,
  CreateAlanCredentialPayload,
} from "../Models/alanCredentials";
import call from "./call";

export const getAlanCredentials = async (): Promise<AlanCredential[]> => {
  const { data } = await call.get("/v1/alan_credentials/", {
    snack: {
      error: "alanCredentials.fetchError",
    },
  });

  return data;
};

export const createAlanCredential = async (
  payload: CreateAlanCredentialPayload
) => {
  const response = await call.post("/v1/alan_credentials/", payload, {
    snack: {
      success: "alanCredentials.createSuccess",
      error: "alanCredentials.createError",
    },
  });

  return response.data;
};

export const deleteAlanCredential = async (id: number) => {
  const response = await call.delete(`/v1/alan_credentials/${id}/`, {
    snack: {
      success: "alanCredentials.deleteSuccess",
      error: "alanCredentials.deleteError",
    },
  });

  return response.data;
};

export const setDefaultAlanCredential = async (id: number) => {
  const response = await call.put(
    `/v1/alan_credentials/default/${id}/`,
    {},
    {
      snack: {
        success: "alanCredentials.defaultSuccess",
        error: "alanCredentials.defaultError",
      },
    }
  );

  return response.data;
};
